export const environment: any = {
  production: false,
  StagingUrl: 'https://creditlimit.stg103.netsmartz.us/api/',
  thirdPartyApiMonthly:`https://clms-api.m-devsecops.com/clapi-backend/api/`,
  //Third Party Apis
  apiUrlThirdParty:
    'https://clms-api.m-devsecops.com/clapi-backend/api/Dealer/SaveCreditLmit',
  unblockApiUrlThirdParty:
    'https://clms-api.m-devsecops.com/clapi-backend/api/Dealer/UnblockDealer',
  GetCurrent_BillingApiUrlThirdParty:
    'https://clms-api.meraswaraj.in/clapi-backend/api/',
 
  // ReCaptcha keys
  // key: 'PJC7LnliwcxXw4PO8Ep3sX9NIL9T5CZ=',
  // captchaKeyLocal: '6Le2AZ0qAAAAAMkwJJr02oZHEHTJ2ZJAUHm2Y7in',
  // captchaKeyLocal: '6LdqpsgqAAAAALTINaCz6mxDqwHrMeXvRB5Dt-uv', //common
  // RandomCharacters:'NkxkcXBzZ3FBQUFBQUxUSU5hQ3o2bXhEcXdIck1lWHZSQjVEdC11dg==',
  // captchaKey:'6Ld2hccqAAAAAK1fc2YsmbLVYuPEZb-G1Ac6Ydc0',
  // iv: 's97IEtMpelScHqu=',
 
  encryptionCharacters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz=',
};
console.log('env', environment.StagingUrl);
 
 